import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/thefuelcompany.webp';
import screenshot_target from '../../../images/letterfunnel/alexanderzandbergen.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Alexander Zandbergen"
      firstname="Alexander"
      companyname="The Fuel Company"
      competition="DKV Mobility en UTA Edenred"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/alexanderzandbergen.js